<template>
  <div class="content">
    <div class="title-text">
      <p class="title">Artist Domain</p>
      <p class="subtitle">
        You can't update or delete the subdomain after you set it.
      </p>
    </div>
    <div class="content-body">
      <div class="domain-card">
        <div class="card-content">
          <div class="subdomain-input">
            <label>
              <span class="label">Subdomain</span>
              <input
                v-model="subdomain"
                :disabled="subdomain_locked"
                type="text"
                placeholder="Please enter subdomain"
              />
              <span class="helper">.vibe.to</span>
            </label>
          </div>
          <button
            v-show="!subdomain_locked"
            :disabled="!subdomain"
            @click="setArtistDomain()"
            class="button-default"
          >
            <span>Set domain</span>
          </button>
        </div>
      </div>
    </div>
    <SnackBar>
      <template v-slot:icon>
        <CopyIcon />
      </template>
    </SnackBar>
  </div>
</template>

<script>
import CopyIcon from "../../../../public/img/icons/copy.svg";
import { M_INSERT_ARTIST_DOMAIN, Q_ARTIST_DOMAINS } from "@/graphql";
import Swal from "sweetalert2";
import "@/assets/scss/custom/vendors-extensions/_sweetalert.scss";
import "@/assets/scss/custom/vendors-extensions/_braintree.scss";
import SnackBar from "@/components/Custom/SnackBar";
export default {
  name: "ArtistDomain",
  components: {
    SnackBar,
    CopyIcon
  },
  data() {
    return {
      domain_id: null,
      subdomain: null,
      subdomain_locked: false
    };
  },
  apollo: {
    $subscribe: {
      domains: {
        query: Q_ARTIST_DOMAINS,
        variables() {
          return {
            artist_id: this.artist.id
          };
        },
        result({ data }) {
          console.log("domains change", data);
          if (data.domains.length) {
            this.subdomain = data.domains[0].domain.replace(".vibe.to", "");
            this.subdomain_locked = true;
            this.domain_id = data.domains[0].id;
            if (data.domains[0].verification_facebook) {
              this.verificationFacebook =
                "facebook-domain-verification=" +
                data.domains[0].verification_facebook;
            }
          } else {
            this.subdomain_locked = false;
            this.subdomain = null;
            this.domain_id = null;
            this.verificationFacebook = null;
          }
        }
      }
    }
  },
  computed: {
    artist() {
      return this.$store.getters.getArtist;
    },
    user() {
      return this.$store.getters.getUser;
    },
    snack() {
      return this.$store.getters.getSnack;
    }
  },
  methods: {
    async setArtistDomain() {
      const domain = this.subdomain.replace(".vibe.to", "").toLowerCase();
      const setDomain = await Swal.fire({
        title: `Set subdomain to`,
        html: `
        <p class="subtitle">${domain}.vibe.to</p>
        <p class="description">You can't change it later.</p>
        `,
        type: "warning",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, set domain",
        cancelButtonText: "No, not yet",
        confirmButtonClass: "button-default big",
        cancelButtonClass: "button-secondary big",
        buttonsStyling: false
      });
      console.log({ setDomain });
      if (setDomain.value) {
        try {
          let mutationResponse = await this.$apollo.mutate({
            mutation: M_INSERT_ARTIST_DOMAIN,
            variables: {
              artist_id: this.artist.id,
              domain: `${domain}.vibe.to`
            }
          });

          if (mutationResponse.data.insert_domains_one?.id) {
            this.subdomain_locked = true;
            this.domain_id = mutationResponse.data.insert_domains_one.id;
            await this.$store.dispatch("snack", {
              text: "Success! Artist subdomain has been set!"
            });
          }
        } catch (err) {
          console.log(err);
          if (err.message.includes("Uniqueness violation")) {
            await this.$store.dispatch("snack", {
              type: "error",
              text: "Oops! This domain is already taken."
            });
          } else {
            await this.$store.dispatch("snack", {
              type: "error",
              text: `Oops! ${err.message.replace("GraphQL error: ", "")}`
            });
          }
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.domain-card {
  padding: 0 24px 24px;
  /* BG/type2 */
  background: $bg-type-2;
  /* Shadow */
  box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
  border-radius: 10px;
  .card-top {
    .card-title {
      /* 18/SemiBold */
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      /* White */
      color: white;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
    .card-text {
      margin: 0;
      font-size: 14px;
      line-height: 24px;
      /* Text/type0 */
      color: $text-type-0;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
  }
  .card-content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .subdomain-input {
      margin-top: 24px;
      width: 100%;
      display: flex;
      label {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        .label {
          margin-left: 11px;
          width: 100%;
          /* 12/Bold */
          font-weight: bold;
          font-size: 12px;
          line-height: 15px;
          /* Text/type1 */
          color: #8786ab;
        }
        input {
          margin-top: 6px;
          padding: 13px 11px;
          //width: 100%;
          flex: 1;
          /* Purple-dark */
          background: $purple-dark;
          /* Purple-stroke */
          border: 1px solid $purple-stroke;
          box-sizing: border-box;
          border-radius: 5px;
          outline: none;
          //border: none;
          color: $text-type-0;
          /* 14/Regular */
          font-size: 14px;
          line-height: 17px;
          &:focus {
            outline: none;
            //border: 1px solid $purple;
          }
          &::placeholder {
            color: $text-type-2;
            /* 14/Regular */
            font-size: 14px;
            line-height: 17px;
          }
        }
        .helper {
          padding: 0 12px;
          /* 18/Regular */
          font-size: 18px;
          line-height: 26px;
          text-align: right;
          /* Text/type0 */
          color: $text-type-0;
          mix-blend-mode: normal;
          opacity: 0.9;
        }
      }
    }
    button {
      margin-top: 18px;
      padding: 9px 30px;
      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }
}
</style>
